import React from 'react';

import { FormField } from '../../form';
import type { FieldRenderProps } from '../../form';
import UploadFieldAdapter from './UploadFieldAdapter';

interface UploadFieldProps {
  name: string;
  options: any;
  buttonText?:
    | {
        default: string;
        more?: string;
      }
    | string;
  labelText?: string;
  disabled?: boolean;
  onChange?: (...args: any[]) => void;
  validate?: (value?: any[]) => string | undefined;
}

const Upload: React.FC<Partial<FieldRenderProps> & UploadFieldProps> = ({
  name,
  buttonText,
  labelText,
  disabled = false,
  options,
  validate,
  onChange,
}) => {
  return (
    <FormField
      component={UploadFieldAdapter}
      name={name}
      options={options}
      disabled={disabled}
      buttonText={buttonText}
      labelText={labelText}
      validate={validate}
      onChange={onChange}
    />
  );
};

export default Upload;
